// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e123ae77","455":"e63009e8","488":"b4d89e16"}[chunkId] + ".chunk.js";
};